import { IconSend as Send } from "@tabler/icons-react";

interface ComposerSendButtonProps {
  sending: boolean;
  disabled: boolean;
}

/**
 * 发送期间保留同一个图标和固定尺寸，只用静态色彩反馈 busy。
 * 不使用旋转环，避免极短请求引发视觉闪烁或低帧率下的不均匀转动。
 */
export function ComposerSendButton({ sending, disabled }: ComposerSendButtonProps) {
  return (
    <button
      type="submit"
      className={`herskin-icon-button herskin-icon-button--md herskin-icon-button--accent composer-send-button${sending ? " composer-send-button--busy" : ""}`}
      aria-label={sending ? "正在发送消息" : "发送消息"}
      aria-busy={sending || undefined}
      title={sending ? "正在提交消息" : "发送消息"}
      disabled={disabled || sending}
    >
      <span className="herskin-icon-button__icon" aria-hidden="true">
        <Send />
      </span>
    </button>
  );
}
